import { useTranslation } from '@/i18n/client';
import to from 'await-to-js';
import cn from 'clsx';
import { observer } from 'mobx-react';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useNavigate } from 'react-router-dom';
// 组件
import RepayOrderModal from '@/app/checkout/components/repayOrderModal';
import { useStores } from '@/app/csr-src/models';
import AfsRecordList from '@/app/csr-src/pages/afterSales/components/afsRecordList';
import UKMaskLoading from '@/components/UKMaskLoading/index';
import UKToast from '@/components/UKToast/index';
import CDNImage from '@/components/cdnImage/cdnImage';
import JDIPrice from '@/components/price/index';
import { useStores as appUseStores } from '@/models';
import { Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import AgeTipsModal from '../ageTipsModal';
import ApplySuccessModal from '../applySuccessModal';
import CommonButton from '../commonButton';
import ConfirmModal from '../confirmModal';
import CountDown from '../countDown';
import InvoiceModal from '../invoiceModal';
import PickUpCodeModal from '../pickUpCodeModal';
import PickupDetailsModal from '../pickupDetailsModal';
import RefundModal from '../refundModal';
import RefundTipsModal from '../refundTipsModal';
import ReturnProductModal from '../returnProductModal';
import ReturnRequestModal from '../returnRequestModal';
import SelectReasonModal from '../selectReasonModal';
import Stepper from '../stepper';
import TrackModal from '../trackModal';
// 样式
import styles from './index.module.scss';
// 接口
import {
  cancelOrder,
  delHistoryOrder,
  fetchLogisticsList,
  preCancelOrder,
} from '@/apis/order/order.api';
import {
  AddressInfoVo,
  ButtonInfoDTOListVo,
  CancelInfoVo,
  DeliveryinfoVo,
  DetailWareInfoListVo,
  ICancelOrderReq,
  ILogisticsListRes,
  IOrderDetailReq,
  InvoiceInfoVo,
  LocalInfoDTO,
  LogisticsInfoVo,
  OrderStatusVo,
  PreCancelDTO,
  PriceInfoVo,
  RefundInfoVo,
  TagContentVo,
  TagMainContentMap,
  WareInfoListVo,
} from '@/apis/order/order.interface';
// 图标
import LocationSVG from '@/assets/icons/AddressIcon.svg';
import ShippedIcon from '@/assets/icons/ShippedIcon.svg';
import TipIcon from '@/assets/icons/TipIcon.svg';
import VectorDown from '@/assets/icons/VectorDownBig.svg';
import WarningIcon from '@/assets/icons/WarningIcon.svg';
// 埋点
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25344';
// utils
import { ITEM_TYPE } from '@/components/product/const';
import { addCartUtil } from '@/utils/cartUtils';
import { imageUtil } from '@/utils/imageUtil';
// mock
// import { mock } from "./mock";

interface orderDetailStatusProps {
  orderInfo: {
    orderId: string;
    orderStatusDTO: OrderStatusVo;
    buttonInfoDTOList: ButtonInfoDTOListVo[];
    logisticsInfoDTO: LogisticsInfoVo;
    cancelInfoDTO: CancelInfoVo;
    wareInfoDTOList: DetailWareInfoListVo[];
    showLogisticsInfo?: boolean;
    showCancelReason?: boolean;
    showAfsProgressInfo?: boolean;
    showCancelInfo?: boolean;
    invoiceInfoDTO?: InvoiceInfoVo;
    priceInfoDTO?: PriceInfoVo;
    addressInfoDTO?: AddressInfoVo;
    showRefundInfo?: boolean;
    refundInfoDTO?: RefundInfoVo;
    orderTagContentVO: TagContentVo;
    localInfo?: LocalInfoDTO;
    deliveryinfoDTO?: DeliveryinfoVo;
  };
  onRefresh?: () => void;
}

const orderDetailStatus: React.FC<orderDetailStatusProps> = observer(({ orderInfo, onRefresh }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const { orderStore } = useStores();
  const { cartStore } = appUseStores();

  const packageWrapRef = useRef<HTMLDivElement>(null);

  const {
    orderStatusDTO,
    buttonInfoDTOList,
    orderId,
    logisticsInfoDTO,
    wareInfoDTOList,
    showCancelReason,
    showAfsProgressInfo,
    showCancelInfo,
    cancelInfoDTO,
    invoiceInfoDTO,
    showLogisticsInfo,
    addressInfoDTO,
    showRefundInfo,
    refundInfoDTO,
    orderTagContentVO,
    localInfo,
    deliveryinfoDTO,
  } = orderInfo || {};
  const { postCode } = addressInfoDTO || {};
  const { orderStatusName, orderStatusId, remainingPaymentTime, cancelReason, cancelProcessing } =
    orderStatusDTO || {};
  const { stateDesc, message } = logisticsInfoDTO || {};
  const {
    selfPickupName,
    selfPickupAddress,
    pickCodePicUrl,
    selfPickupBusinessHours,
    opeModel,
    thirdLogisUrl,
  } = deliveryinfoDTO || {};

  // 埋点相关
  const commonTrackParams = {
    orderId: String(orderId),
    orderStatus: orderStatusDTO?.orderStatusId as '1' | '3' | '8' | '6' | '5',
  };
  const packageNum =
    logisticsInfoDTO?.shippedPackageNum || 0 + logisticsInfoDTO?.deliveredPackageNum || 0;

  const navigate = useNavigate();

  const [againCancel, setAgainCancel] = useState(false);
  const [cancelModalData, setCancelModalData] = useState<PreCancelDTO | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(orderStore.isShowPayModal || false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [showReturnProductModal, setShowReturnProductModal] = useState(false);
  const [showReturnRequestModal, setShowReturnRequestModal] = useState(false);
  const [showApplySuccessModal, setShowApplySuccessModal] = useState(false);
  const [afsServiceId, setAfsServiceId] = useState('');
  const [showRefundTipsModal, setShowRefundTipsModal] = useState(false);
  const [tipsContent, setTipsContent] = useState('');
  const [showCancelTipsModal, setShowCancelTipsModal] = useState(false);
  const [showAgeTipsModal, setShowAgeTipsModal] = useState(false);
  const [showPickupDetailsModal, setShowPickupDetailsModal] = useState(false);
  const [showPickUpCodeModal, setShowPickUpCodeModal] = useState(false);

  const [curTagItem, setCurTagItem] = useState<TagMainContentMap | null>(null);

  // JDISVOrderListOrderStatusTypeWaitingPay = 1, //待支付、等待付款确认
  // JDISVOrderListOrderStatusTypeWaitingDelivery = 3, //待发货 processing
  // JDISVOrderListOrderStatusTypeCompleted = 5, //已完成
  // JDISVOrderListOrderStatusTypeCancelled = 6, //已取消
  // JDISVOrderListOrderStatusTypeWaitingSelfDelivery = 7, //等待自提
  // JDISVOrderListOrderStatusTypeWaitingReceipt = 8, //运输中 shipped
  const type = orderStatusId || '';

  // 获取物流信息
  const [logisticsList, setLogisticsList] = useState<ILogisticsListRes | null>(null);
  const [isShowMore, setIsShowMore] = useState<boolean>(false);

  // 当前展示的第几个包裹
  const [curIndex, setCurIndex] = useState<number>(0);
  const [showFoldBtn, setShowFoldBtn] = useState<boolean>(false);
  const [openStates, setOpenStates] = useState<boolean>(false);

  const loadLogisticslList = async () => {
    const requestData: IOrderDetailReq = { orderId: String(orderId) };
    const [err, logisticsListData] = await to(fetchLogisticsList(requestData));

    if (err) {
      // setError("Failed to fetch order details");
      setLogisticsList(null);
    } else {
      setLogisticsList(logisticsListData as ILogisticsListRes);
      // setLogisticsList(mock.data);
      checkPackageListOverflow();
      // setError(null);
    }
  };

  useEffect(() => {
    if (type === '3' || type === '8' || type === '7') {
      loadLogisticslList();
    }
  }, []);

  const checkPackageListOverflow = () => {
    setTimeout(() => {
      const containerElement = packageWrapRef.current;
      if (containerElement) {
        const packageWrapHeight = containerElement.clientHeight;
        if (packageWrapHeight > 52) {
          // 超过一行才展示
          setShowFoldBtn(true);
        } else {
          setShowFoldBtn(false);
        }
      }
    }, 30);
  };

  const { multiPackageList = [] } = logisticsList || {};
  const {
    promiseTitle,
    promiseValue,
    selectedPromiseTitle,
    selectedPromiseValue,
    carrierCodeTitle,
    carrierCode,
    waybillNumTitle,
    waybillNum,
    packageLogistics,
    skuList,
    highValueVerification,
  } = multiPackageList[curIndex] || {};

  // 复制物流单号
  const copyHandler = () => {
    UKToast.show({
      content: t('order.orderDetail.common.copySuccessTips'), // 弹窗内容
      icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
      duration: 2000, // 不写的话默认3000
    });
  };

  const handleBtnClick = (clickType: number) => {
    // JDISVOrderListOrderActionFloorModelButtonTypePay = 1, /**< 1:去支付 */
    // JDISVOrderListOrderActionFloorModelButtonTypeBuyAgain = 2, /**< 2:再次购买 */
    // JDISVOrderListOrderActionFloorModelButtonTypeInvite = 3, /**< 3:查看邀请（暂无使用） */
    // JDISVOrderListOrderActionFloorModelButtonTypeConfirmReceive = 5, /**< 5:确认收货 */
    // JDISVOrderListOrderActionFloorModelButtonTypeEvaluate = 6, /**< 6:评价晒单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeLogistics = 7, /**< 7:查看物流 */
    // JDISVOrderListOrderActionFloorModelButtonTypeRestoreOrder = 8, /**< 8:还原订单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeRemainderOrder = 11, /**< 11:我要催单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeCompleteRemainder = 12, /**< 12:已催单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeCheckInvoice = 14, /**< 14:查看发票 */
    // JDISVOrderListOrderActionFloorModelButtonTypeCancelOrder = 15, /**< 15:取消订单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeApplyAfterSale = 16, /**< 16:申请售后 */
    // JDISVOrderListOrderActionFloorModelButtonTypeApplyInvoice = 17, /**< 17:申请开票 */
    // JDISVOrderListOrderActionFloorModelButtonTypeApplyRefund = 18, /**< 18:申请退款 */
    // JDISVOrderListOrderActionFloorModelButtonTypeDeleteOrder = 19, /**< 19:删除订单 */
    // JDISVOrderListOrderActionFloorModelButtonTypeShareFirend = 20,/**< 20:邀请好友 */
    // JDISVOrderListOrderActionFloorModelButtonTypeRefundDetail = 21, /**< 21:退款明细 */
    // JDISVOrderListOrderActionFloorModelButtonTypeRemainderDetail = 22, /**< 22:催单详情 */
    // JDISVOrderListOrderActionFloorModelButtonTypeForceDelete = 23, /**< 23:彻底删除(宜宾) */
    // JDISVOrderListOrderActionFloorModelButtonTypePayFirstMoney = 24, /**< 24:支付定金*/
    // JDISVOrderListOrderActionFloorModelButtonTypePayLastMoney = 25, /**< 25:支付尾款*/
    // JDISVOrderListOrderActionFloorModelButtonTypeModifyOrder  = 27, /**< 27:修改订单*/
    // JDISVOrderListOrderActionFloorModelButtonTypeDelayReceive = 29, /**< 29:延迟收货*/
    if (clickType === 15) {
      // 取消订单
      // 埋点
      sendClickTrack.Orderdetail_Cancel(commonTrackParams);
      // 增加二次确认
      preCancelOrderHandler();
    } else if (clickType === 2) {
      // 再次购买
      // 埋点
      sendClickTrack.OrderDetail_BuyAgain(commonTrackParams);
      // 数据处理
      const formatWareList = wareInfoDTOList.map((item) => {
        const addonProducts =
          item?.serviceProductList?.map((ele) => ({
            skuId: ele.skuId,
            num: ele.buyCount || 1, // 服务品数量默认为1
            itemType: ITEM_TYPE.BigItem,
          })) || undefined;
        return {
          skuId: item.wareId,
          num: item.buyCount,
          addonProducts,
        };
      });
      // navigate("/Cart", { state: { productList: formatWareList } });
      // 只有加车成功或者商品缺货才跳转购物车，其他的在订单当前页提醒
      try {
        UKMaskLoading.show();
        addCartUtil(formatWareList, false, true, '', true)
          .then((res) => {
            const { result, isDefinedToast } = res || {};
            if (isDefinedToast || result?.code === '200') {
              cartStore.setCartList(formatWareList);
              cartStore.setCartData(result?.data);
              cartStore.setAddCartCode(result?.code);
              router.push('/cart');
            }
          })
          .finally(() => {
            UKMaskLoading.close();
          });
      } catch (error) {
        console.log(error);
      }
    } else if (clickType === 19) {
      // 删除订单
      // 埋点
      sendClickTrack.Orderdetail_Delete(commonTrackParams);
      setShowConfirmModal(true);
    } else if (clickType === 1) {
      // 去支付
      // 埋点
      sendClickTrack.OrderDetail_PayNow(commonTrackParams);
      setShowPayModal(true);
    } else if (clickType === 6) {
      // 跳转评价
      // 埋点
      sendClickTrack.OrderDetail_Review(commonTrackParams);
      navigate(`/Review?orderId=${orderId}`);
    } else if (clickType === 7) {
      // 7:查看物流
      // 埋点
      sendClickTrack.Orderdetail_OrderTrack(commonTrackParams);
      setShowTrackModal(true);
    } else if (clickType === 14) {
      // 查看发票
      // 埋点
      sendClickTrack.OrderDetail_InvoiceService(commonTrackParams);
      setShowInvoiceModal(true);
    } else if (clickType === 16) {
      // 申请售后
      // 埋点
      sendClickTrack.Orderdetail_OrderRefund(commonTrackParams);
      setShowReturnProductModal(true);
    }
  };

  // 格式化处理打标数据
  const filterAndSortVerificationItems = (data: any) => {
    return data?.tagSet
      .map((tag: string) => ({
        tagKey: tag,
        ...data?.tagMainContentMap[tag],
      })) // 根据 tagSet 获取对应的内容 同时添加 key 字段
      .filter(Boolean) // 过滤掉 undefined（处理拼写错误或不存在的标签）
      .filter((item: any) => item?.scene === 'verification') // 筛选 verification 场景
      .sort((a: any, b: any) => b?.priority - a?.priority); // 按优先级降序排序
  };

  const statusRender = () => {
    let dom = null;
    const showBtnList = buttonInfoDTOList.sort((a, b) => b.sort - a.sort);
    const formatTagList = filterAndSortVerificationItems(orderTagContentVO);
    dom = (
      <>
        <div className={styles.detail_title_wrap}>
          <div
            className={styles.status_txt}
            exptag={'exp|' + EXPOSURE_RECORD.Orderdetail_OrderStatusPV}
            data-exptag-config={JSON.stringify({
              useClick: false,
              stay_duration: 0.3,
              repeated: false,
              area_rate: 0.5,
            })}
            data-exptag-json-param={JSON.stringify(commonTrackParams)}
          >
            {orderStatusName}
          </div>
          {buttonInfoDTOList?.length ? (
            <div className={styles.btn_group}>
              {showBtnList.map((item, index) => {
                // 埋点相关
                let buttonExpoName = '';
                if (item.showLabelId === 2) {
                  // 再次购买
                  buttonExpoName = EXPOSURE_RECORD.OrderDetail_BuyAgainExpo;
                } else if (item.showLabelId === 1) {
                  // 去支付
                  buttonExpoName = EXPOSURE_RECORD.OrderDetail_PayNowExpo;
                } else if (item.showLabelId === 6) {
                  // 跳转评价
                  buttonExpoName = EXPOSURE_RECORD.OrderDetail_ReviewExpo;
                } else if (item.showLabelId === 7) {
                  // 查看物流
                  buttonExpoName = EXPOSURE_RECORD.Orderdetail_OrderTrackExpo;
                } else if (item.showLabelId === 19) {
                  // 删除订单
                  buttonExpoName = EXPOSURE_RECORD.Orderdetail_DeleteExpo;
                } else if (item.showLabelId === 14) {
                  // 发票
                  buttonExpoName = EXPOSURE_RECORD.OrderDetail_InvoiceServiceExpo;
                } else if (item.showLabelId === 15) {
                  // 取消订单
                  buttonExpoName = EXPOSURE_RECORD.Orderdetail_CancelExpo;
                } else if (item.showLabelId === 16) {
                  // 申请售后
                  buttonExpoName = EXPOSURE_RECORD.Orderdetail_OrderRefundExpo;
                }
                const buttonExpoParams = commonTrackParams;
                // to ship 和shipped状态下不展示track按钮
                return (type === '3' || type === '8' || type === '7') &&
                  item.showLabelId === 7 ? null : (
                  <CommonButton
                    key={item.showLabelId}
                    size='large'
                    variant={
                      item.showLabelId === 1 || item.showLabelId === 2 ? 'contained' : 'outlined'
                    }
                    style={index === 0 ? {} : { marginLeft: '12px' }}
                    onClick={() => handleBtnClick(item.showLabelId)}
                    exptag={'exp|' + buttonExpoName}
                    data-exptag-config={JSON.stringify({
                      useClick: false,
                      stay_duration: item.showLabelId === 15 ? 0 : 0.3,
                      repeated: false,
                      area_rate: item.showLabelId === 15 ? 0.01 : 0.5,
                    })}
                    data-exptag-json-param={JSON.stringify(buttonExpoParams)}
                  >
                    {item.showLabel}
                  </CommonButton>
                );
              })}
            </div>
          ) : null}
        </div>
        {/* 烟酒年龄限制提示 */}
        {/* {orderTagContentVO && orderTagContentVO?.tagSet?.includes("isAdultProduct") && (
          <div
            className={styles.ageTips}
            onClick={(event) => {
              event.stopPropagation();
              setShowAgeTipsModal(true);
            }}
          >
            <WarningIcon />
            <div className={styles.ageTipsContent}>{orderTagContentVO?.tagMainContentMap?.isAdultProduct?.title}</div>
            <VectorDown className={styles.entry_ico} />
          </div>
        )} */}
        {/* 含冷冻品标识 */}
        {orderTagContentVO && orderTagContentVO?.tagSet?.includes('freeze') && (
          <div className={styles.frozenWrap}>
            <WarningIcon />
            <div className={styles.frozenContent}>
              {orderTagContentVO?.tagMainContentMap?.freeze?.content}
            </div>
          </div>
        )}
        {/* 一单多包裹场景 */}
        {multiPackageList?.length > 1 ? (
          <div
            className={cn(styles.packageOuterWrap, {
              [styles.oneLineStyle]: showFoldBtn && !openStates,
            })}
          >
            <div className={styles.packageWrap} ref={packageWrapRef}>
              {/* 1 Item */}
              {multiPackageList.map((item, index) => {
                return (
                  <div
                    key={`multiPackageItem${index}`}
                    className={cn(styles.packageItem, {
                      [styles.activePackageItem]: index === curIndex,
                    })}
                    onClick={() => setCurIndex(index)}
                  >
                    {t('order.orderDetail.orderDetailStatus.packageText')} {index + 1}
                    {/* 兼容skuList为空的情况 */}
                    {calcNum(item?.skuList) ? (
                      <span>
                        ({calcNum(item?.skuList)}{' '}
                        {t('order.orderDetail.orderDetailStatus.item', {
                          count: calcNum(item?.skuList),
                        })}
                        )
                      </span>
                    ) : (
                      <span>({t('order.orderDetail.orderDetailStatus.noNumberText')})</span>
                    )}
                  </div>
                );
              })}
            </div>
            {showFoldBtn && (
              <div
                className={styles.viewAllWrap}
                onClick={() => {
                  setOpenStates((pre) => !pre);
                }}
              >
                {openStates
                  ? t('order.orderList.orderItems.retractText')
                  : t('checkout.orderCard.viewAll')}
                <VectorDown
                  className={cn(styles.more_ico, {
                    [styles.retract_ico]: openStates,
                  })}
                />
              </div>
            )}
          </div>
        ) : null}
        {/* 展示打标标签，如烟酒年龄限制、高价值商品等 */}
        {!!formatTagList?.length &&
          formatTagList
            .filter((tagEle: TagMainContentMap) => tagEle?.title)
            .map((tagItem: TagMainContentMap, tagIndex: number) => {
              return (
                <div
                  className={styles.ageTips}
                  onClick={(event) => {
                    event.stopPropagation();
                    setCurTagItem(tagItem);
                    setShowAgeTipsModal(true);
                  }}
                  key={`tagItem${tagIndex}`}
                >
                  <div className={styles.mainTagContent}>
                    <WarningIcon />
                    <div className={styles.ageTipsContent}>{tagItem?.title}</div>
                    <VectorDown className={styles.entry_ico} />
                  </div>
                  {/* 单包裹展示 */}
                  {!tagItem?.extMap?.isMultiPincode && tagItem?.extMap?.verificationCode ? (
                    <div className={styles.subTagContent}>
                      {t('order.orderList.orderItems.verificationCode')}
                      <span className={styles.codeStyle}>{tagItem?.extMap?.verificationCode}</span>
                    </div>
                  ) : null}
                  {/* 多包裹展示 */}
                  {tagItem?.extMap?.isMultiPincode && highValueVerification?.pinCode ? (
                    <div className={styles.subTagContent}>
                      {t('order.orderList.orderItems.verificationCode')}
                      <span className={styles.codeStyle}>{highValueVerification?.pinCode}</span>
                    </div>
                  ) : null}
                </div>
              );
            })}
        {statusLeftRender()}
      </>
    );
    return dom;
  };

  // 计算package items
  const calcNum = (list: WareInfoListVo[]) => {
    return list.reduce((sum: number, item) => sum + Number(item.buyCount), 0);
  };

  // 展示pick-up楼层信息
  const pickUpFloorRender = () => {
    let dom = null;
    dom = (
      <div className={styles.pickUpWrap}>
        {/* 需要判断多包裹场景 packageNum大于1代表多包裹 没有自提标题和自提时间 就不展示 */}
        {packageNum > 1 || stateDesc ? (
          <div className={styles.infoWrap}>
            <ShippedIcon width={16} height={18} />
            <div className={styles.infoTitle}>{packageNum > 1 ? message : stateDesc}</div>
            {/* opeModel 1代表三方 */}
            {opeModel === 1 && thirdLogisUrl && (
              <div className={styles.btnWrap}>
                <CommonButton
                  variant='outlined'
                  onClick={() => {
                    window.location.href = thirdLogisUrl;
                  }}
                >
                  {t('order.orderDetail.pickupDetailsModal.modalTitle')}
                </CommonButton>
              </div>
            )}
            {/* opeModel 0 代表三方 */}
            {opeModel === 0 && pickCodePicUrl && (
              <div className={styles.btnWrap}>
                <CommonButton
                  variant='outlined'
                  onClick={() => {
                    setShowPickUpCodeModal(true);
                  }}
                >
                  {t('order.orderDetail.orderDetailStatus.pickUpCode')}
                </CommonButton>
              </div>
            )}
          </div>
        ) : null}
        {selfPickupName ? (
          <div className={styles.pickUpAddress}>
            <div className={styles.infoWrap}>
              <LocationSVG width={16} height={18} />
              <div className={styles.infoTitle}>
                {t('order.orderDetail.orderDetailStatus.pickUpPoint')}
              </div>
              <div className={styles.btnWrap}>
                <CommonButton
                  variant='outlined'
                  onClick={() => {
                    setShowPickupDetailsModal(true);
                  }}
                >
                  {t('order.orderDetail.applySuccessModal.detailBtn')}
                </CommonButton>
              </div>
            </div>
            <div className={styles.detailInfoWrap}>
              <div className={styles.logisticsTitle}>{selfPickupName}</div>
              {selfPickupAddress ? (
                <div className={styles.logisticsDesc}>{selfPickupAddress}</div>
              ) : null}
              <div className={styles.openingTimeItemTitle}>
                {t('afterSales.afterSalesAccordion.openingTime')}
              </div>
              {selfPickupBusinessHours?.map((item, index) => {
                return (
                  <div className={styles.openingTimeItem} key={`pickupOpeningTimeItem_${index}`}>
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );
    return dom;
  };

  const statusLeftRender = () => {
    let dom = null;
    // 取消中不展示倒计时
    if (type === '1' && remainingPaymentTime && remainingPaymentTime >= 0 && !cancelProcessing) {
      dom = (
        <div className={cn(styles.detail_desc_wrap, styles.detail_desc_special_wrap)}>
          <div className={styles.count_down_wrap}>
            {t('order.orderList.orderItems.toPay')}
            <CountDown
              size='large'
              endTime={remainingPaymentTime || 0}
              endHandler={() => {
                // 延迟两秒调用，防止中台状态未变更
                setTimeout(() => {
                  onRefresh && onRefresh();
                }, 2000);
              }}
              externalStyles={{ marginLeft: '12px' }}
            />
          </div>
        </div>
      );
    } else if (type === '5') {
      dom = (
        <AfsRecordList
          orderId={orderId}
          refreshHandler={onRefresh}
          clickTrackHandler={() => {
            sendClickTrack.OrderDetail_AftersaleDetail(commonTrackParams);
          }}
          commonTrackParams={commonTrackParams}
        />
      );
    } else {
      dom = (
        <>
          {/* 展示物流信息 */}
          {!packageLogistics?.length && !promiseValue ? null : (
            <div className={styles.detail_desc_wrap}>
              <div className={styles.left_part}>
                {/* <div className={styles.delivery_title}>
                  <i />
                  {type === "8"
                    ? t("order.orderDetail.orderDetailStatus.orderShipped")
                    : t("order.orderDetail.orderDetailStatus.orderPlaced")}
                </div> */}
                {/* 展示pick-up楼层信息 */}
                {type === '7' ? pickUpFloorRender() : null}
                <>
                  {carrierCodeTitle ? (
                    <div className={styles.delivery_wrap}>
                      <span>{carrierCodeTitle}</span>
                      <span className={cn({ [styles.errorText]: !carrierCode })}>
                        {carrierCode || t('order.orderDetail.trackModal.noDataText')}
                      </span>
                    </div>
                  ) : null}
                  {waybillNumTitle ? (
                    <div className={styles.delivery_wrap}>
                      <span>{waybillNumTitle}</span>
                      {waybillNum ? (
                        <div>
                          <span>{waybillNum}</span>
                          <CopyToClipboard text={waybillNum || ''} onCopy={() => copyHandler()}>
                            <span className={styles.copy_btn}>
                              {t('order.orderDetail.common.copyText')}
                            </span>
                          </CopyToClipboard>
                        </div>
                      ) : (
                        <div className={styles.errorText}>
                          {t('order.orderDetail.trackModal.noDataText')}
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
                {promiseValue ? (
                  <div className={styles.delivery_wrap}>
                    <span>{promiseTitle}</span>
                    <span>{promiseValue}</span>
                  </div>
                ) : null}
                {selectedPromiseValue ? (
                  <div className={styles.delivery_wrap}>
                    <span>{selectedPromiseTitle}</span>
                    <span>{selectedPromiseValue}</span>
                  </div>
                ) : null}
                {/* 一单多包裹场景 */}
                {multiPackageList?.length > 1 ? (
                  <div className={styles.packageContentWrap}>
                    <div className={styles.packageTitle}>
                      <div>{t('order.orderDetail.orderDetailStatus.packageText')}</div>
                      <div className={styles.packageTitleRight}>
                        {/* 兼容skuList为空的情况  */}
                        {calcNum(skuList) > 0 ? (
                          <>
                            {`${t('cart.priceInfo.total')} ${calcNum(skuList)} ${t(
                              'order.orderDetail.orderDetailStatus.item',
                              { count: calcNum(skuList) },
                            )}`}
                            {skuList?.length > 5 && <VectorDown className={styles.more_ico} />}
                          </>
                        ) : (
                          <>{t('order.orderDetail.orderDetailStatus.noNumberText')}</>
                        )}
                      </div>
                      {/* 全部商品图列表，hover时展示 */}
                      {skuList?.length > 5 && (
                        <div className={styles.allPackageWareListOuterWrap}>
                          <div className={styles.allPackageWareListWrap}>
                            {skuList?.map((ele, index) => {
                              return (
                                <div className={styles.productImg} key={`packageWareKey${index}`}>
                                  <CDNImage
                                    src={ele.imageUrl || ''}
                                    width={75}
                                    height={75}
                                    style={{
                                      objectFit: 'contain',
                                      height: '75px',
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                    {/* 默认展示前五个商品图 */}
                    {calcNum(skuList) > 0 && (
                      <div className={styles.packageWareListWrap}>
                        {skuList?.slice(0, 5)?.map((ele, index) => {
                          return (
                            <div className={styles.productImg} key={`packageWareKey${index}`}>
                              <CDNImage
                                src={ele.imageUrl || ''}
                                width={75}
                                height={75}
                                style={{
                                  objectFit: 'contain',
                                  height: '75px',
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              <div className={styles.right_part}>
                <Stepper
                  logisticsInfoDTOList={
                    isShowMore ? packageLogistics : packageLogistics?.slice(0, 5)
                  }
                />
                {/* 默认最多展示5条最新物流进度 可点击“View all”展开，“Retract”收起 */}
                {packageLogistics?.length > 5 && (
                  <div
                    className={styles.viewAllWrap}
                    onClick={() => {
                      setIsShowMore((pre) => !pre);
                    }}
                  >
                    {isShowMore
                      ? t('order.orderList.orderItems.retractText')
                      : t('checkout.orderCard.viewAll')}
                    <VectorDown
                      className={cn(styles.more_ico, {
                        [styles.retract_ico]: isShowMore,
                      })}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          {/* 超时取消 */}
          {showCancelReason && cancelReason ? (
            <div className={cn(styles.detail_desc_wrap, styles.detail_desc_wrap_separate)}>
              <div className={styles.timeout_cancel}>{cancelReason}</div>
            </div>
          ) : null}
          {/* 拒收取消 showcancelInfo 展示退款信息 */}
          {showCancelInfo && (
            <div className={cn(styles.detail_desc_wrap, styles.detail_desc_wrap_separate)}>
              <div className={styles.after_sales_wrap}>
                <i className={styles.cancel_ico} />
                <span className={styles.after_sales_title}>
                  {cancelInfoDTO.cancelProgressStatus}
                </span>
                <span className={styles.after_sales_detail}>
                  {cancelInfoDTO.cancelProgressText}
                </span>
              </div>
              <CommonButton variant='outlined' onClick={() => {}}>
                {t('order.orderDetail.orderDetailStatus.refundDetailBtnText')}
              </CommonButton>
            </div>
          )}
          {/* 展示退款信息 */}
          {showRefundInfo &&
            (type === '6' ? (
              <div className={cn(styles.detail_desc_wrap, styles.detail_desc_wrap_separate)}>
                <div className={styles.after_sales_wrap}>
                  <i className={styles.after_sales_ico} />
                  <span className={styles.after_sales_title}>
                    {refundInfoDTO?.refundProgressText}
                    {!refundInfoDTO?.refundSubText ? (
                      <TipIcon
                        className={styles.tip_ico}
                        onClick={() => {
                          setTipsContent(refundInfoDTO?.tips || '');
                          setShowRefundTipsModal(true);
                        }}
                      />
                    ) : null}
                  </span>
                  {refundInfoDTO?.refundAmount ? (
                    <span className={styles.after_sales_detail}>
                      {refundInfoDTO?.refundSubText}
                      <JDIPrice
                        symbol={localInfo?.currencySymbol || ''}
                        price={refundInfoDTO?.refundAmount}
                        uiType={2}
                        containerStyle={{
                          fontSize: '14px',
                          color: '#505259',
                          height: '18px',
                          lineHeight: '18px',
                          // marginLeft: "4px",
                        }}
                      />
                    </span>
                  ) : (
                    <span className={styles.after_sales_detail}>
                      {refundInfoDTO?.refundSubText}
                    </span>
                  )}
                </div>
                <div className={styles.after_sales_wrap}>
                  <span className={styles.after_sales_detail}>
                    {refundInfoDTO?.refundApplyTimeTextForPc}
                  </span>
                  {/* 点击弹出退款明细弹窗 */}
                  {refundInfoDTO?.showRefundDetailsButton && (
                    <CommonButton
                      variant='outlined'
                      onClick={() => {
                        // 埋点
                        sendClickTrack.OrderDetail_RefundDetail(commonTrackParams);
                        setShowRefundModal(true);
                      }}
                      style={{ marginLeft: 8 }}
                      exptag={'exp|' + EXPOSURE_RECORD.OrderDetail_RefundDetailExpo}
                      data-exptag-config={JSON.stringify({
                        useClick: false,
                        stay_duration: 0.3,
                        repeated: false,
                        area_rate: 0.5,
                      })}
                      data-exptag-json-param={JSON.stringify(commonTrackParams)}
                    >
                      {t('order.orderDetail.orderDetailStatus.refundDetailBtnText')}
                    </CommonButton>
                  )}
                </div>
              </div>
            ) : (
              <div className={cn(styles.detail_desc_wrap, styles.detail_desc_wrap_separate)}>
                {refundInfoDTO?.refundProgressText ? (
                  <div className={styles.after_sales_wrap}>
                    <i className={styles.after_sales_ico} />
                    <span className={styles.after_sales_title}>
                      <span>{refundInfoDTO?.refundProgressText}</span>
                      {/* 取消中，并且是退款中才展示 */}
                      <TipIcon
                        className={styles.tip_ico}
                        onClick={() => {
                          setTipsContent(refundInfoDTO?.tips || '');
                          setShowRefundTipsModal(true);
                        }}
                      />
                    </span>

                    <span className={styles.after_sales_detail}>
                      {refundInfoDTO?.refundSubText}
                    </span>
                  </div>
                ) : null}
                <div className={styles.after_sales_wrap}>
                  <span className={styles.after_sales_detail}>
                    {refundInfoDTO?.refundApplyTimeTextForPc}
                  </span>
                  {/* 点击弹出退款明细弹窗 */}
                  {refundInfoDTO?.showRefundDetailsButton && (
                    <CommonButton
                      variant='outlined'
                      onClick={() => {
                        // 埋点
                        sendClickTrack.OrderDetail_RefundDetail(commonTrackParams);
                        setShowRefundModal(true);
                      }}
                      style={{ marginLeft: 8 }}
                      exptag={'exp|' + EXPOSURE_RECORD.OrderDetail_RefundDetailExpo}
                      data-exptag-config={JSON.stringify({
                        useClick: false,
                        stay_duration: 0.3,
                        repeated: false,
                        area_rate: 0.5,
                      })}
                      data-exptag-json-param={JSON.stringify(commonTrackParams)}
                    >
                      {t('order.orderDetail.orderDetailStatus.refundDetailBtnText')}
                    </CommonButton>
                  )}
                </div>
              </div>
            ))}
        </>
      );
    }
    return dom;
  };

  // 删除订单确认操作
  const handleDelConfirm = () => {
    // 埋点
    sendClickTrack.Orderdetail_ComfirmDelete(commonTrackParams);
    setShowConfirmModal(false);
    handleDelHistory();
  };

  // 删除订单操作
  const handleDelHistory = async () => {
    const requestData: IOrderDetailReq = { orderId: String(orderId) };
    const [err, delHistoryOrderData] = await to(delHistoryOrder(requestData));

    if (err) {
      UKToast.show({
        content: t('order.orderList.orderItems.deleteFailTips'), // 弹窗内容
        icon: 'fail', // 可选：success, fail, loading, warn, info，影响图标
        duration: 2000, // 不写的话默认3000
      });
    } else {
      if (delHistoryOrderData.result) {
        // 返回订单列表
        UKToast.show({
          content: t('order.orderList.orderItems.deleteSuccessTips'), // 弹窗内容
          icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
        setTimeout(() => {
          navigate('/profile/my-orders');
          // onRefresh && onRefresh();
        }, 2000);
      } else {
        UKToast.show({
          content:
            delHistoryOrderData.updateShowText || t('order.orderList.orderItems.deleteFailTips'), // 弹窗内容
          icon: 'fail', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      }
    }
  };

  // 提交取消原因
  const handleSubmitConfirm = (id: string, desc?: string) => {
    // 埋点
    if (desc) {
      sendClickTrack.OrderDetail_CancelLayer_SubmitReason({
        ...commonTrackParams,
        cancelreason: desc,
      });
    }
    setShowReasonModal(false);
    cancelOrderHandler(id);
  };

  // 取消订单操作
  const cancelOrderHandler = async (id: string) => {
    const requestData: ICancelOrderReq = {
      orderId: String(orderId),
      refundReasonId: String(id) || '',
    };
    const [err, cancelOrderData] = await to(cancelOrder(requestData));

    if (err) {
      UKToast.show({
        content: t('order.orderList.orderItems.cancelFailTips'), // 弹窗内容
        icon: 'fail', // 可选：success, fail, loading, warn, info，影响图标
      });
    } else {
      if (cancelOrderData.cancelResult === '1') {
        if (cancelOrderData?.confirmCode === '1005' || type === '3') {
          // 已发货小于5英镑的仅退款code 或者 processing下取消 跳转新的页面
          const id = cancelOrderData?.confirmCode === '1005' ? '1' : '2';
          navigate(`/order-cancelled?styleId=${id}&orderId=${orderId}`);
        } else {
          // 刷新列表
          UKToast.show({
            content:
              cancelOrderData.cancelInfo || t('order.orderList.orderItems.cancelSuccessTips'), // 弹窗内容
            icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
            duration: 2000, // 不写的话默认3000
          });
          setTimeout(() => {
            onRefresh && onRefresh();
          }, 2000);
        }
      } else {
        if (cancelOrderData?.confirmCode === '-1004') {
          // 已发货大于5英镑的异常code 只弹框
          setShowCancelTipsModal(true);
        } else {
          UKToast.show({
            content: cancelOrderData.cancelInfo || t('order.orderList.orderItems.cancelFailTips'), // 弹窗内容
            icon: 'fail', // 可选：success, fail, loading, warn, info，影响图标
            // duration: 2000, // 不写的话默认3000
          });
        }
      }
    }
  };

  // 预取消订单操作
  const preCancelOrderHandler = async () => {
    const requestData: IOrderDetailReq = { orderId: String(orderId) };
    const [err, cancelOrderData] = await to(preCancelOrder(requestData));
    if (cancelOrderData) {
      setCancelModalData(cancelOrderData);
    }
    setAgainCancel(true);
  };

  // view Detail 按钮点击跳转售后详情页，关闭弹框
  const refreshDetailPage = () => {
    setShowApplySuccessModal(false);
    navigate(`/my-orders/refund?afsServiceId=${afsServiceId}&orderId=${orderId}`);
  };
  return (
    <div className={styles.wrap}>
      {statusRender()}
      {showConfirmModal && (
        <ConfirmModal
          content={t('order.orderList.orderItems.deleteConfirmText')}
          confirmHandler={handleDelConfirm}
          closeHandler={() => {
            // 埋点
            sendClickTrack.Orderdetail_CancelDelete(commonTrackParams);
            setShowConfirmModal(false);
          }}
          trackingPointParams={{
            exptag: 'exp|' + EXPOSURE_RECORD.Orderdetail_DeletePopExpo,
            'data-exptag-config':
              '{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}',
            'data-exptag-json-param': JSON.stringify(commonTrackParams),
          }}
        />
      )}
      {showReasonModal && (
        <SelectReasonModal
          orderId={orderId}
          confirmHandler={handleSubmitConfirm}
          closeHandler={() => {
            // 埋点
            sendClickTrack.OrderDetail_CancelLayer_Close(commonTrackParams);
            setShowReasonModal(false);
          }}
          trackHandler={(extraParams: { cancelreason: string }) => {
            sendClickTrack.OrderDetail_CancelLayer_SelectReason({
              ...commonTrackParams,
              ...extraParams,
            });
          }}
          commonTrackParams={commonTrackParams}
        />
      )}
      {/* 取消二次确认弹窗 */}
      <Dialog
        open={againCancel}
        onClose={() => setAgainCancel(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        sx={
          cancelModalData?.sceneCode === 'unCancel'
            ? {
                '& .MuiPaper-root': {
                  width: '420px',
                  minWidth: 'auto',
                },
              }
            : {}
        }
      >
        <DialogContent
          exptag={'exp|' + EXPOSURE_RECORD.OrderDetail_CancelPopExpo}
          data-exptag-config={JSON.stringify({
            useClick: false,
            stay_duration: 0.3,
            repeated: false,
            area_rate: 0.5,
          })}
          data-exptag-json-param={JSON.stringify(commonTrackParams)}
        >
          <DialogContentText>
            {cancelModalData?.cancelShowImg ? (
              <div className={styles.cancelImgWrap}>
                <img
                  className={styles.cancelImg}
                  src={imageUtil.concatImgUrlWithoutForceHttps(cancelModalData?.cancelShowImg)}
                  alt=''
                />
              </div>
            ) : null}
            <div
              className={cn(styles.modalTitle, {
                [styles.modalTitleBold]: cancelModalData?.cancelShowText,
              })}
            >
              {cancelModalData?.cancelShowTitle ||
                t('order.orderList.orderItems.cancelConfirmText')}
            </div>
            {cancelModalData?.cancelShowText ? (
              <div className={styles.modalDesc}>{cancelModalData?.cancelShowText}</div>
            ) : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {cancelModalData?.sceneCode === 'unCancel' ? (
            <CommonButton
              variant='outlined'
              onClick={() => {
                // 埋点
                sendClickTrack.OrderDetail_NoCancel(commonTrackParams);
                setAgainCancel(false);
              }}
            >
              {t('order.orderDetail.orderDetailStatus.okBtn')}
            </CommonButton>
          ) : (
            <>
              <CommonButton
                variant='outlined'
                onClick={() => {
                  // 埋点
                  sendClickTrack.OrderDetail_ComfirmCancel(commonTrackParams);
                  setAgainCancel(false);
                  setShowReasonModal(true);
                }}
              >
                {t('order.orderDetail.orderDetailStatus.confirmCancelBtn')}
              </CommonButton>
              <CommonButton
                variant='contained'
                sx={{ boxShadow: 'none' }}
                onClick={() => {
                  // 埋点
                  sendClickTrack.OrderDetail_NoCancel(commonTrackParams);
                  setAgainCancel(false);
                  // 继续支付逻辑
                  if (orderStatusDTO?.orderStatusId === '1') {
                    setShowPayModal(true);
                  }
                }}
              >
                {orderStatusDTO?.orderStatusId === '1'
                  ? t('order.orderDetail.orderDetailStatus.continuePayBtn')
                  : t('order.orderDetail.orderDetailStatus.backToOrderBtn')}
              </CommonButton>
            </>
          )}
        </DialogActions>
      </Dialog>
      {/* pay now */}
      {/* 去支付弹框 */}
      {showPayModal && (
        <RepayOrderModal
          orderId={orderId}
          open={showPayModal}
          onClose={() => {
            setShowPayModal(false);

            orderStore?.setIsShowPayModal(false);
          }}
          onFresh={() => {
            // onRefresh && onRefresh();
            // 清除缓存，返回all tab页面
            sessionStorage.removeItem('orderInfo');
            orderStore.setOrderType('4096');
            orderStore.setPageNum(1);
            orderStore?.setIsShowPayModal(false);
            navigate('/profile/my-orders');
          }}
        />
      )}
      {/* 物流轨迹弹框 */}
      {showTrackModal && (
        <TrackModal
          isOpen={showTrackModal}
          closeHandler={() => setShowTrackModal(false)}
          orderId={orderId}
          title={orderStatusName || ''}
          commonTrackParams={commonTrackParams}
        />
      )}
      {/* 发票弹框 */}
      {showInvoiceModal && (
        <InvoiceModal
          isOpen={showInvoiceModal}
          closeHandler={() => setShowInvoiceModal(false)}
          orderId={orderId}
        />
      )}
      {/* 退款明细弹框 */}
      {showRefundModal && (
        <RefundModal
          isOpen={showRefundModal}
          closeHandler={() => setShowRefundModal(false)}
          handleConfirmClick={() => {}}
          orderId={orderId}
        />
      )}
      {/* 售后商品选择弹窗 */}
      {showReturnProductModal && (
        <ReturnProductModal
          isOpen={showReturnProductModal}
          closeHandler={() => setShowReturnProductModal(false)}
          handleConfirmClick={() => {
            setShowReturnProductModal(false);
            setShowReturnRequestModal(true);
          }}
          orderId={orderId}
          skuList={wareInfoDTOList.map((item) => {
            return {
              skuId: item.wareId || '',
              skuUUid: item.skuUuid || '',
            };
          })}
        />
      )}
      {/* 售后申请表单弹窗 */}
      {showReturnRequestModal && (
        <ReturnRequestModal
          isOpen={showReturnRequestModal}
          closeHandler={() => setShowReturnRequestModal(false)}
          handleConfirmClick={(val) => {
            onRefresh && onRefresh();
            setShowReturnRequestModal(false);
            setShowApplySuccessModal(true);
            setAfsServiceId(val);
          }}
          orderId={orderId}
          postCode={postCode || ''}
          skuIds={wareInfoDTOList.map((item) => item.wareId).join(',')}
        />
      )}
      {/* 取消成功弹框 */}
      {showApplySuccessModal && (
        <ApplySuccessModal
          isOpen={showApplySuccessModal}
          closeHandler={() => setShowApplySuccessModal(false)}
          viewDetailHandler={refreshDetailPage}
        />
      )}
      {/* 取消tips弹框 */}
      {showRefundTipsModal && (
        <RefundTipsModal
          isOpen={showRefundTipsModal}
          closeHandler={() => setShowRefundTipsModal(false)}
          content={tipsContent}
        />
      )}
      {/* 已发货大于5英镑的取消弹框 */}
      {showCancelTipsModal && (
        <Dialog open={showCancelTipsModal} onClose={() => setShowCancelTipsModal(false)}>
          <DialogContent>
            {t('order.orderDetail.orderDetailStatus.tranistModalContent')}
          </DialogContent>

          {/* Button */}
          <DialogActions>
            <CommonButton variant='contained' onClick={() => setShowCancelTipsModal(false)}>
              {t('common.btnText.ok')}
            </CommonButton>
          </DialogActions>
        </Dialog>
      )}
      {/* 年龄提示弹框 */}
      {/* {showAgeTipsModal && (
        <AgeTipsModal
          isOpen={showAgeTipsModal}
          closeHandler={() => setShowAgeTipsModal(false)}
          modalInfo={orderTagContentVO?.tagMainContentMap?.isAdultProduct}
        />
      )} */}
      {/* 打标详情提示框 */}
      {showAgeTipsModal && (
        <AgeTipsModal
          isOpen={showAgeTipsModal}
          closeHandler={() => setShowAgeTipsModal(false)}
          modalInfo={curTagItem}
        />
      )}
      {/* pickUpCode 弹框 */}
      <PickUpCodeModal
        isOpen={showPickUpCodeModal}
        closeHandler={() => {
          setShowPickUpCodeModal(false);
        }}
        modalInfo={deliveryinfoDTO}
      />
      {/* Pickup details弹框 */}
      <PickupDetailsModal
        isOpen={showPickupDetailsModal}
        closeHandler={() => setShowPickupDetailsModal(false)}
        modalInfo={deliveryinfoDTO}
      />
    </div>
  );
});

export default orderDetailStatus;
